<template>
    <div class="twoSubBetParlayBanner">
        <img
            class="cloudDecoLeft"
            src="@/assets/images/twoSubBetParlay/twoSubBetParlay-cloudDeco-left.png"
            alt=""
        >
        <div class="infoText">
            <div class="cupBg">
                <img
                    class="cupBgDeco"
                    src="@/assets/images/twoSubBetParlay/twoSubBetParlay-trophyBgDeco.png"
                    alt=""
                >
                <SvgIcon
                    name="icon-sport-color-worldCupColor"
                    size="40"
                />
            </div>
            <p>
                <I18nT keypath="mp_two_sub_bets_special_offer">
                    <template #events>
                        <strong> {{ i18n.t('mp_two_sub_bets_special_offer_slot_events') }}</strong>
                    </template>
                </I18nT>
            </p>
            <img
                class="soccerDeco"
                src="@/assets/images/twoSubBetParlay/twoSubBetParlay-worldCup2026-soccer.png"
                alt=""
            >
        </div>
        <img
            class="cloudDecoRight"
            src="@/assets/images/twoSubBetParlay/twoSubBetParlay-cloudDeco-right.png"
            alt=""
        >
    </div>
</template>

<script lang="ts" setup>
    import SvgIcon from '@/components/common/SvgIcon.vue';
    import { i18n } from '@/core/lib/i18n';
</script>

<style lang="scss" scoped>
    @import "@/components/event/TwoSubBetParlayBanner";
</style>
